/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-04-23 15:10:21
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-23 15:59:20
 */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";
import ar from "i18n/ar.js";
import fr from "i18n/fr.js";
import en from "i18n/en.js";

let langUse: string = 'en';


intl.init({
  currentLocale: langUse,
  locales: {
    ar,
    fr,
    en,
  }
});

ReactDOM.render(<Routes />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
